import Layout from 'components/Layout';
import Card from 'components/generic/card';
import LoadingContainer from 'components/checkout/components/BasketOverview/components/LoadingContainer';
import { Spacing24 } from 'autogen/design-tokens/tokens';
import type { BasketViewModel } from 'autogen/swagger/all';
import { useGetBasketQuery } from 'autogen/swagger/all/hooks';
import BasketContent from './BasketContent/BasketContent';
import BasketFooter from './BasketFooter/BasketFooter';
import BasketHeader from './BasketHeader/BasketHeader';
import BasketWasModifiedQuickView from './BasketWasModifiedQuickView/BasketWasModifiedQuickView';
import BasketMessages from './BasketMessage/BasketMessages';
import { useDeliveryFixStore } from '../shared/deliveryFixStore';

export default function Basket({ model: initialModel }: { model: BasketViewModel }) {
    const { showDeliveryFixBasketMessage } = useDeliveryFixStore();
    const {
        data: fetchedModel,
        isFetching,
        isFetchedAfterMount
    } = useGetBasketQuery(
        {
            showDeliveryFixModal: false,
            showDeliveryFixMessage: !!showDeliveryFixBasketMessage
        },
        { initialData: initialModel, refetchOnWindowFocus: false, refetchOnMount: false }
    );
    const model = fetchedModel || initialModel;

    const { basketContent } = model;
    const {
        basket: { basketFooter, messages, isEmpty },
        modifiedBasket,
        checkoutButton,
        giftCardInfo
    } = basketContent;
    const isLoading = isFetchedAfterMount && isFetching;

    return (
        <Card size={{ xs: 'md', lg: 'xl' }}>
            <LoadingContainer isLoading={isLoading}>
                <Card.Content>
                    <Layout.Flex.Column gap={Spacing24}>
                        {/* Basket Messages (achievements, nudging, clubmatas) */}
                        <BasketMessages model={messages} />

                        {/* Basket Header (title, checkout actions) */}
                        <BasketHeader model={model} />

                        {/* Basket Content (items, gifts, validationMessages, Donation, signup, nudge) */}
                        {!isEmpty && <BasketContent model={basketContent} />}

                        {/* Basket Footer (personal offers, points, voucher, price summary, checkout actions) */}
                        {!isEmpty && (
                            <BasketFooter
                                model={basketFooter}
                                checkoutButtonModel={checkoutButton}
                                giftCardInfo={giftCardInfo}
                            />
                        )}

                        {/* BasketWasModified QuickView */}
                        <BasketWasModifiedQuickView model={modifiedBasket} />
                    </Layout.Flex.Column>
                </Card.Content>
            </LoadingContainer>
        </Card>
    );
}
